module.exports = __webpack_public_path__ + "static/media/education.39cbd0c0.PNG";